import { gql } from '../__generated__/gql';

const GET_KIOSKS = gql(`
  query Kiosks(
    $orderBy: [KioskOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: KioskWhereInput
  ) {
    kiosks(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      name
    }
  }
`);

export default GET_KIOSKS;
